export enum CustomerClassificationEnum {
  TBA = 0,
  ToCall = 1,
  DoNotCall = 2
}
